module.exports = __webpack_public_path__ + "img/gwnu_gallery1.e9062885.jpg";